var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.completeTemplates.length
        ? _c("v-client-table", {
            ref: "table",
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.completeTemplates,
              columns: _vm.table.columns,
              options: _vm.table.options,
              name: "manageTemplates",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "name",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [_vm._v("\n        " + _vm._s(row.name) + "\n      ")]
                      ),
                    ]
                  },
                },
                {
                  key: "description",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.truncateText(
                                  row.description,
                                  "description-" + index
                                )
                              ) +
                              "\n        "
                          ),
                          _vm.showExpansibleButton(row.description)
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "btn btn-link text-primary p-0 clickable",
                                  staticStyle: { "font-size": "10px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.collapseText(
                                        "description-" + index
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.isCollapse("description-" + index)
                                          ? _vm.$t("global.actions.showLess")
                                          : _vm.$t("global.actions.showMore")
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "message",
                  fn: function (ref) {
                    var row = ref.row
                    var index = ref.index
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.truncateText(
                                  row.message,
                                  "message-" + index
                                )
                              ) +
                              "\n        "
                          ),
                          _vm.showExpansibleButton(row.message)
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "btn btn-link text-primary p-0 clickable",
                                  staticStyle: { "font-size": "10px" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.collapseText(
                                        "message-" + index
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.isCollapse("message-" + index)
                                          ? _vm.$t("global.actions.showLess")
                                          : _vm.$t("global.actions.showMore")
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "createdAt",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm._f("formatTimeAgo")(row.createdAt)) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ml-2 pr-4 d-flex flex-row align-items-center request-trash",
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.$t("e-sign-package.editTemplate"),
                                  expression:
                                    "$t('e-sign-package.editTemplate')",
                                },
                              ],
                              staticClass: "pr-3 clickable",
                            },
                            [
                              _c("icon", {
                                staticClass: "text-primary",
                                attrs: { name: "pencil" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEditTemplate(
                                      row.eSignTemplateId
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("inline-prompt", {
                            staticStyle: { "font-size": "0.8rem" },
                            attrs: {
                              "action-type": "delete",
                              placement: "left",
                            },
                            on: {
                              accept: function ($event) {
                                return _vm.handleDeleteTemplate(
                                  row.eSignTemplateId
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1519433678
            ),
          })
        : _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("e-sign-package.messages.emptyTemplates")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }